import defaultPrimary from '../default/primary';

const custom = (params) => defaultPrimary(params);

export default custom;
